import Cookie from "js-cookie";
import { Permission } from "../literals";
export interface Session {
    sessionKey: string;
    consoleUserId: string;
    consoleUserName: string;
    consoleUserPermissions: Permission[];
}

const COOKIE_NAME = "session";
const API_KEY_COOKIE_NAME = "apiKey";

export const setSessionCookie = (session?: Session) => {
    Cookie.set(COOKIE_NAME, JSON.stringify(session));
    // ログイン中のAPIKeyとしてsessionKeyを利用している（画像参照APIのCookie認証用）
    session?.sessionKey && Cookie.set(API_KEY_COOKIE_NAME, session.sessionKey);
};

export const getSessionCookie = (): Session => {
    const c = Cookie.get(COOKIE_NAME);
    if (!c) {
        return {
            sessionKey: "",
            consoleUserId: "",
            consoleUserName: "",
            consoleUserPermissions: [],
        };
    }
    return JSON.parse(c) as Session;
};

export const isLoggedIn = (): boolean => {
    return Cookie.get(COOKIE_NAME) != undefined;
};

export const deleteSessionCookie = () => {
    Cookie.remove(COOKIE_NAME);
    Cookie.remove(API_KEY_COOKIE_NAME);
};

const COOKIE_IS_LAST_LOGIN_OPT = "isLastLoginOpt";
// 最後のログインがoptだった場合にtrueを返す。
// このデータはCookieとして30日間保存されている
export function isLastLoginOtp(): boolean {
    return Cookie.get(COOKIE_IS_LAST_LOGIN_OPT) ? true : false;
}

// ログインに成功したらこの関数を読んで次回ログインで同じLoginTypeにさせる
export function setLastLoginOtp(isOtp: boolean) {
    if (isOtp) {
        Cookie.set(COOKIE_IS_LAST_LOGIN_OPT, "true", { expires: 30 });
    } else {
        Cookie.remove(COOKIE_IS_LAST_LOGIN_OPT);
    }
}
